<script>
    import { onMount, tick } from "svelte";
    import Chart from 'chart.js/auto';
    import chartService from '../../../services/chart.js';
    import Gradient from "../../../services/gradient.js";


    let { certificates = [] } = $props();

    let canvas = $state();
    let chart;
    let totals = {};
    let tooltips_titles = {};
    let gradientArray;

    if(certificates.length > 1){
        gradientArray = new Gradient()
            //.setColorGradient("#B10c52", "#230B0C")
            .setColorGradient("#343a40","#3c8dbc") // opcion 1
            .setMidpoint((certificates.length < 5) ? certificates.length : 5)
            .getColors();
        ;
        for(let [index, color] of gradientArray.entries()){
            gradientArray[index] = color + "AE";
        }
    }

    onMount(async () => {
        await tick();

        let context  = canvas.getContext('2d');

        let chartData = {
            labels   : [],
            datasets : {
                backgroundColor : gradientArray ? gradientArray : ["#343a40AE","#3c8dbcAE"],
                data: [],
            },
        }
        for (const cert of certificates) {
            let title = cert.id.length > 20 ? cert.id.substring(0, 20) + "..." : cert.id;
            chartData.labels.push(title);
            tooltips_titles[title] = cert.id;
            chartData.datasets.data.push(cert.value);
        }

        chart = new Chart(context, {
            type: 'bar',
            options: {
                barThickness: 50,
                // Elements options apply to all of the options unless overridden in a dataset
                // In this case, we are setting the border of each horizontal bar to be 2px wide
                elements: {
                    bar: {
                        inflateAmount: 1,
                        borderWidth: 0,
                        borderRadius: 2
                    }
                },
                responsive: true,
                maintainAspectRatio: false,
                aspectRatio: 1,
                plugins:{
                    legend: {
                        display: false,
                        position: 'bottom',
                        labels: {
                            font: {
                                fontFamily: 'Montserrat',
                                size: 12
                            }
                        }
                    },
                    tooltip:{
                        callbacks: {
                            title: function(tooltipItem) {
                                return tooltips_titles[tooltipItem[0].label];
                            },
                            fontFamily: 'Montserrat'
                        }
                    },
                },
                title: {
                    display: false,
                },
                animation : {
                    animateScale: true,
                    animateRotate: true,
                },
                scales: {
                    y: {
                        beginAtZero : true,
                        min: 0,
                        ticks: {
                            stepSize: 1,
                            font: {
                                family: 'Montserrat'
                            }
                        }
                    },
                    x: {
                        ticks: {
                            font: {
                                family: 'Montserrat',
                            },
                            display: true,
                            //maxRotation: 0,
                            //position: "right",
                        },
                    },
                },
                onHover : (event) => {
                    canvas.style.cursor = "pointer";
                },
                onClick: (event)=> {
                    window.location.href = `/property/asset/ssl/cert_issuer_cn/values?value=${encodeURIComponent(event.chart.tooltip.title[0])}`
                }
            },
            data : {
                labels  : chartData.labels,
                datasets: [chartData.datasets],
                borderWidth: 2,
                borderRadius: 5,
                borderSkipped: false,
            },
        });
    });
</script>
<style>
    /*#chart-vuls-by-severity {
        height: 250px !important;
        margin: 0 auto;
        width: 808px;
    }*/
</style>
<canvas bind:this={canvas} id="chart-vuls-by-severity" class:chart-has-no-data="{totals["critical"] == 0 && totals["high"] == 0 && totals["medium"] == 0 && totals["low"] == 0}" ></canvas>
